export default __webpack_public_path__ + "c62bec459f5aa6457b78253b7f3b33f6.svg";